export default function StampSlide({ onNext }: { onNext: () => void }) {
  return (
    <div className="relative w-full h-full flex items-center justify-center overflow-hidden">
      <div
        className="font-display text-[12rem] text-white/90 uppercase tracking-tight leading-none text-center select-none"
        style={{
          transform: "rotate(-12deg)",
          textShadow: "0 0 80px rgba(158,255,0,0.3), 0 0 160px rgba(158,255,0,0.1)",
          WebkitTextStroke: "3px rgba(158,255,0,0.6)",
        }}
      >
        Next<br />Robinhood
      </div>
    </div>
  );
}
